<script setup lang="ts">
import type { HealthState } from '@/types'
import { computed } from 'vue'
import { healthPresentation } from '@/lib/health'

const props = withDefaults(
  defineProps<{
    state: HealthState
    size?: 'sm' | 'md' | 'lg'
  }>(),
  { size: 'sm' },
)

const presentation = computed(() => healthPresentation(props.state))
</script>

<template>
  <UBadge
    :color="presentation.color"
    :icon="presentation.icon"
    :size="size"
    variant="subtle"
  >
    {{ presentation.label }}
  </UBadge>
</template>
